var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-list",staticStyle:{"width":"100%","height":"100%"}},[_c('iframe',{ref:"iframe",staticStyle:{"border":"none"},attrs:{"height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }